import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Badge from '../Badge/Badge';

import IconButton from './IconButton';

import styles from './IconButtonWithBadge.module.scss';

const IconButtonWithBadge = ({ badgeText, className, icon, onClick }) => (
	<div className={cx(styles.iconButtonWithBadge, className)}>
		<IconButton icon={icon} onClick={onClick}>
			{badgeText && <Badge className={styles.badge}>{badgeText}</Badge>}
		</IconButton>
	</div>
);

IconButtonWithBadge.defaultProps = {
	badgeText: '',
	className: '',
};

IconButtonWithBadge.propTypes = {
	badgeText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	className: PropTypes.string,
	icon: PropTypes.node.isRequired,
	onClick: PropTypes.func.isRequired,
};

export default IconButtonWithBadge;
